(function($) {
    [].forEach.call(document.querySelectorAll('.js-open-in-iframe-popin'), function(popin) {
        popin.addEventListener('click', function(e) {
            e.preventDefault();
            $.magnificPopup.open({
                items: {
                    src: popin.getAttribute('href')
                },
                type: 'iframe',
                mainClass: 'mfp-iframe-popin'
            });
        });
    });
})(jQuery.noConflict());
